import { ApplyFilter } from "@coworker/apprestructured/src/shared/filters/types/apply";
import {
  FilterType,
  FilterValue,
  InputType,
  SelectFilter,
} from "@coworker/apprestructured/src/shared/filters/types/filter";
import { useCustomAllSelectOption } from "@coworker/apprestructured/src/shared/filters/utils/useAllSelectOption";
import { useTranslation } from "@coworker/locales";
import { AggregatedArticle } from "../hooks/useAggregatedArticles";
import { EDS_DATES_ID } from "./useEdsDatesSelectArticleFilter";

export const ALERT_ID = "alert";

function useAlertSelectFilter() {
  const { t } = useTranslation();
  const defaultValue = { filterId: ALERT_ID, value: "" };

  return useCustomAllSelectOption(
    {
      inputType: InputType.Select,
      filterType: FilterType.Filter,
      id: ALERT_ID,
      title: t("alertsFilterTitleString"),
      options: [
        {
          value: "eds",
          title: t("edsString"),
          dependentOfFilterId: EDS_DATES_ID,
        },
        {
          value: "pastEds",
          title: t("pastEdsString"),
          dependentOfFilterId: EDS_DATES_ID,
        },
        { value: "salesStop", title: t("salesStopString") },
        { value: "outOfStock", title: t("outOfStockString") },
      ],
      enabled: true,
      defaultValue,
    },
    t("allArticlesString")
  );
}

function useAlertSelectArticleFilter() {
  const filter: ApplyFilter<SelectFilter, AggregatedArticle> = {
    filter: useAlertSelectFilter(),
    filterCompare: (item: AggregatedArticle, { value }: FilterValue) => {
      switch (value) {
        case "eds":
          return item.eds && item.eds.validToDate
            ? item.eds.validToDate.getTime() >= new Date().getTime()
              ? true
              : false
            : false;
        case "pastEds":
          return item.eds && item.eds.validToDate
            ? item.eds.validToDate.getTime() < new Date().getTime()
              ? true
              : false
            : false;
        case "salesStop":
          return item.salesStop ? true : false;
        case "outOfStock": {
          if (item.stockInfo) {
            return (
              item.stockInfo.available === 0 && item.stockInfo.elevated === 0
            );
          }
          return false;
        }
        default:
          return true;
      }
    },
  };

  return filter;
}

export { useAlertSelectArticleFilter };
